/*
 * Copyright (c) 2022 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 4/7/2022
 */

import React, { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { Button, IconButton, OutlinedInput, Typography, Grid } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useCreateOfferMutation } from "../../Store/Services/OfferService";
import { useForm } from "react-hook-form";
import CategoryList from "../Shared/CategoryList";
import { useDispatch } from "react-redux";
import { openAddOfferModal } from "../../Store/Slices/offerSlice";

import styles from "./Offer.module.css";

const schema = yup
  .object({
    off: yup.string().required(""),
    offerDesc: yup.string().required(""),
    day: yup.string().required(""),
    catId: yup.string().required(""),
  })
  .required();

const AddOffer = ({ handleClose }) => {

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [CreateOffer] = useCreateOfferMutation();

  const [openCatList, setOpenCatList] = useState(false);
  const [catName, setCatName] = useState("");
  const [selectedCat, setSelectedCat] = useState();

  const dispatch = useDispatch();

  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {

    const dataSet = {
      ...data,
      catId: selectedCat,
    };

    try {
      const respond = await CreateOffer(dataSet).unwrap();
      dispatch(openAddOfferModal(false));
      toast.success("Offer successfully created!",  {position:'bottom-right'});
    } catch (err) {
      console.error("Failed to save offer: ", err);
      toast.error("Erorr, something went wrong!",  {position:'bottom-right'});
    }
    handleClose();
  };

  return (
    <>
      <div className={styles.headingContainer}>
        <Typography fontWeight={600} variant={"h6"}>
          Offer Creation
        </Typography>
        <IconButton className={styles.closeButton} onClick={handleClose}>
          <Close />
        </IconButton>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
      <Grid item xs={12} sx={{ width: "100%" }}>
        <div className={styles.formItem}>
          <label className={styles.formLabel}>Offer Description:</label>
          {errors.offerDesc && errors.offerDesc.type === "required" && (
            <span className={styles.validation}> *</span>
          )}
          <OutlinedInput
            {...register("offerDesc")}
            className={styles.formInput}
            placeholder="Enter Description"
            size="small"
            fullWidth
          />
        </div>
        </Grid>
        <Grid item xs={12} sx={{ width: "100%" }}>
        <div className={styles.formItem}>
          <label className={styles.formLabel}>Category:</label>

          {selectedCat === "" && <span className={styles.validation}> *</span>}
          <OutlinedInput
           {...register("catId")}
            className={styles.formInput}
            placeholder="Select Category"
            size="small"
            onClick={() => setOpenCatList(true)}
            autoComplete="off"
            fullWidth
            value={catName}
          />
        </div>
        </Grid>
        <Grid item container xs={12} columnSpacing={2} rowSpacing={1}>
          <Grid item xs={12} md={6} sx={{ width: "50%" }}>
        <div className={styles.formItem}>
          <label className={styles.formLabel}>Day :</label>
          {errors.day && errors.day.type === "required" && (
            <span className={styles.validation}> *</span>
          )}
          <OutlinedInput
            {...register("day")}
            className={styles.formInput}
            type="date"
            placeholder="Enter Offer"
            size="small"
            fullWidth
          />
        </div>
        </Grid>
        <Grid item xs={12} md={6} sx={{ width: "50%" }}>
        <div className={styles.formItem}>
          <label className={styles.formLabel}>Offer %:</label>
          {errors.off && errors.off.type === "required" && (
            <span className={styles.validation}> *</span>
          )}
          <OutlinedInput
            {...register("off")}
            className={styles.formInput}
            placeholder="Enter Offer"
            type="number"
            size="small"
            fullWidth
          />
        </div>
        </Grid>
        </Grid>
        <div className={styles.buttonContainer}>
          <Button
            type="submit"
            className={styles.submitButton}
            variant="contained"
          >
            Save
          </Button>
        </div>
      </form>

      <CategoryList
        open={openCatList}
        onClose={() => setOpenCatList(false)}
        setSelectedCat={setSelectedCat}
        selectedCat={selectedCat}
        setCatName={setCatName}
      />
    </>
  );
};

export default AddOffer;
